import { useMutation } from "@tanstack/react-query";
import { api } from "shared/api";
import { getFormattedBumbalRequest } from "shared/utils/date";

const createBumbalDate = async ({
  selectedDate,
  type,
  orderId,
}: {
  selectedDate: Date;
  orderId: string;
  type: string;
}) => {
  const res = await api().gersCreateStandardProductOrderBumbalDate(orderId, {
    dateFrom: getFormattedBumbalRequest(selectedDate).dateFrom,
    dateTo: getFormattedBumbalRequest(selectedDate).dateTo,
    type: type,
  });

  return res.data;
};

export const useCreateStandardOrderBumbalDate = () =>
  useMutation(createBumbalDate);
